import React, { useEffect, useState } from 'react';

//API
import autoInfracao_api from '../../../api/autoInfracao_api';

//Context
import { useAuth } from '../../../context/auth';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import AutoDeInfracaoImpressao from '../../../views/Shared/AutoDeInfracaoImpressao';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Helpers
import { showMessage } from '../../../helpers/message';
import { transformValueFloattoFormated } from 'helpers/formats';

export default function AutosInfracoes({ btnVoltar }) {
    const { setLoading } = useAuth();

    //Headers da tabela
    const headers = [
        { value: "Tipo notificação", objectValue: "tipoNotificacao" },
        { value: "Preceitos Legais", objectValue: "preceitosLegais" },
        { value: "Fato Constitutivo", objectValue: "fatoConstitutivo" }, 
        { value: "Data de cadastro", objectValue: "dataCadastro" },
        { value: "Valor da multa", objectValue: "valorMulta" }
    ];

    //Estado que guarda os dados da tabela
    const [listaAutosInfracoes, setListaAutosInfracoes] = useState([]);

    const [visualizacaoAutoInfracao, setVisualizacaoAutoInfracao] = useState(null);

    async function loadAutosInfracoes() {
        setLoading(true);
        try {
            const { data } = await autoInfracao_api.GetList(true);
            setListaAutosInfracoes(data || []);
        } catch (error) {
            showMessage("Error", error.mensage, "error", null);
        }finally {
            setLoading(false);
        }
    }

    async function handleVisualizarAutoInfracao(rowData) {
        setLoading(true);
        try {
            await autoInfracao_api.UpdateDataVisualizacao(rowData.id);
            setVisualizacaoAutoInfracao(rowData);
        } catch (error) {
            showMessage("Error", error.mensage, "error", null);
        }finally {
            setLoading(false);
        }
    }

    const actions = [actionsTable.visualizar(handleVisualizarAutoInfracao)]

    //Carregando os dados da tabela
    useEffect(() => {
        loadAutosInfracoes();
    }, []); 

    return (
        <>
            {visualizacaoAutoInfracao &&
                <AutoDeInfracaoImpressao 
                    hash={visualizacaoAutoInfracao.hash} 
                    handleReturn={() => { 
                        setVisualizacaoAutoInfracao(null);
                        loadAutosInfracoes();
                    }}
                />
            }
            {!visualizacaoAutoInfracao && 
                <MainCard 
                    noCard
                    btnVoltarInTop={() => { btnVoltar() }}
                > 
                    <TabelaListagem 
                        title='Lista de autos de infrações'
                        headers={headers}
                        items={listaAutosInfracoes}
                        actions={actions}
                        options={{ print: false, search: true, pagination: true }}
                    />
                </MainCard>
            }
        </>
    );
}
